import { compose, withHandlers } from 'recompose';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { t } from '../../../../modules/infra/i18n';
import CustomersListItem from './customersListItem';
import withLoading from '../../../common/withLoading';
import { getUserUrlPrefix } from '../../../auth/selectors';
import Pagination from '../../../common/Pagination';

const CustomersList = ({ customers, onPageChange, pagination, userUrlPrefix }) => (
  <div>
    <div className="c-table-card c-table-new u-table-layout-fixed c-no-hover">
      <div className="c-table-card__head">
        <div className="c-table-card__cell c-label u-3/10">{t('customers:list.header.client')}</div>
        <div className="c-table-card__cell c-label u-visible-table-cell-for-large-and-up u-3/10">{t('customers:list.header.email')}</div>
        <div className="c-table-card__cell c-label u-visible-table-cell-for-large-and-up u-2/10">{t('customers:list.header.phone')}</div>
      </div>
    </div>
    <div className="c-table-card c-table-new u-table-layout-fixed u--mt-" data-automation-id="customersList">
      <div className="u-text-center" display-if={!customers || !customers.length}>
        {t('customers:list.no_clients_message')}
      </div>
      {customers.map(customer => (
        <CustomersListItem
          customer={customer}
          key={customer.id}
          userUrlPrefix={userUrlPrefix}
        />
      ))}
    </div>
    <Pagination
      display-if={customers.length}
      onPageChange={onPageChange}
      pageCount={pagination.totalPages}
      currentPage={pagination.page}
    />
  </div>
);
CustomersList.propTypes = {
  customers: PropTypes.arrayOf(PropTypes.object).isRequired,
  userUrlPrefix: PropTypes.string.isRequired,
  onPageChange: PropTypes.func.isRequired,
  pagination: PropTypes.objectOf({
    count: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({
  userUrlPrefix: getUserUrlPrefix(state),
});

export default compose(
  connect(mapStateToProps),
  withLoading,
  withHandlers({
    onPageChange: props => (page) => {
      window.scrollTo(0, 0);
      return props.onPageChange(page);
    },
  })
)(CustomersList);
